import { useTranslation } from 'react-i18next';

export default function FeatureSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="px-4 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            {t('features.title_line1')}<br />
            {t('features.title_line2')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md lg:text-right lg:pt-3">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {/* Card 1 - Large */}
          <div className="lg:col-span-1 bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
                <i className="ri-timer-flash-line text-xl"></i>
              </div>
              <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-3">
                {t('features.card1_title')}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t('features.card1_desc')}
              </p>
            </div>
            <div className="mt-6 rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Productive%20minimalist%20desk%20workspace%20with%20sleek%20laptop%20showing%20organized%20data%20on%20warm%20clay%20toned%20surface%2C%20gentle%20morning%20light%20through%20sheer%20curtains%2C%20clean%20scandinavian%20interior%2C%20warm%20neutral%20atmosphere%2C%20ceramic%20mug%20and%20linen%20notebook%2C%20calm%20focused%20editorial%20lifestyle%20photography%20with%20soft%20organic%20textures&width=800&height=600&seq=feature-v2-time-c1&orientation=landscape"
                alt="Zeitersparnis"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
              <i className="ri-shield-check-line text-xl"></i>
            </div>
            <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-3">
              {t('features.card2_title')}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              {t('features.card2_desc')}
            </p>
            <div className="rounded-xl overflow-hidden aspect-square w-full max-w-[280px]">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20product%20inspection%20scene%20with%20natural%20linen%20fabric%20swatches%20on%20warm%20stone%20surface%2C%20soft%20directional%20light%20revealing%20textile%20grain%2C%20elegant%20quality%20control%20aesthetic%2C%20warm%20neutral%20palette%2C%20refined%20scandinavian%20minimal%20style%2C%20precise%20craftsmanship%20atmosphere%20with%20measuring%20details&width=600&height=600&seq=feature-v2-quality-c2&orientation=squarish"
                alt="Geprüfte Qualität"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
              <i className="ri-refresh-line text-xl"></i>
            </div>
            <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-3">
              {t('features.card3_title')}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              {t('features.card3_desc')}
            </p>
            <div className="rounded-xl overflow-hidden aspect-square w-full max-w-[280px]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20wall%20calendar%20with%20marked%20dates%20on%20warm%20cream%20desk%20setting%2C%20soft%20natural%20daylight%2C%20organized%20planning%20stationery%20scattered%20naturally%2C%20editorial%20productivity%20lifestyle%2C%20warm%20neutral%20tones%2C%20refined%20scandinavian%20minimal%20aesthetic%2C%20fresh%20modern%20atmosphere%20with%20botanical%20accent&width=600&height=600&seq=feature-v2-update-c3&orientation=squarish"
                alt="Immer aktuell"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}